
<template>
  <nav>
    <img alt="Vue logo" src="./assets/logo.png"/>
    <router-link :to="{name: 'home'}">Start</router-link>
    
  </nav> 

  <router-view v-slot="{Component}">
    <transition name="route" mode="out-in">
      <component :is="Component"></component>
    </transition>
  </router-view>

  <!-- <span v-if="$route.fullPath !== '/' && categories[0]" class="material-symbols-outlined arrow" @click="goBack">arrow_back</span> -->
</template>

<script>
  import getDataFirebase from './composables/getDataFirebase';
  export default{
    methods: {
      goBack(){
          this.$router.go(-1)
      }
    },
    setup(){
      const { categories, load } = getDataFirebase()    
      load('sdf1')

      return{
        categories
      }
    }
  }
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
  text-align: right;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  margin: 10px;
}

nav a.router-link-exact-active {
  color: #42b983;
}
nav img{
  width: 105px;
  position: absolute;
  left: 5vw;
}
/* route transitions*/
.route-enter-from{
  opacity: 0;
  transform: translateX(100px);
}
.route-enter-active, .route-leave-active{
  transition: all 0.3s ease-in-out;
}
.route-leave-to{
  opacity: 0;
  transform: translateX(-100px);
}



</style>
